import { render } from "./secondary-product-data.vue?vue&type=template&id=a5d32f86"
import script from "./secondary-product-data.vue?vue&type=script&lang=js"
export * from "./secondary-product-data.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__